module.exports = __webpack_public_path__ + "img/avatar.4317fbd7.png";